/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Badge_SkippedInputs */

const vi_einvoice_badge_skipped = /** @type {(inputs: Einvoice_Badge_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không xuất`)
};

/**

* @param {Einvoice_Badge_SkippedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_badge_skipped = /** @type {((inputs?: Einvoice_Badge_SkippedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Badge_SkippedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_badge_skipped(inputs)
});